@import './pk-line-chart.variables';

:host {
  @apply block w-full;
}
